const gridItemStyle = { display: { sm: 'none', xs: 'block' } };

export { gridItemStyle };
